import { active } from "@api/stores/suppliers/active/api";
import { deactive } from "@api/stores/suppliers/deactive/api";
import { stats } from "@api/stores/suppliers/stats/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  ISuppliersDto,
  ISuppliersGetAllParams,
  ISuppliersResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ISuppliersResponse>>,
  IPathBaseParam,
  IPaginationParams & ISuppliersGetAllParams
>("stores.suppliers");
const postApis = createPostApi<
  IApiResponse<ISuppliersResponse>,
  IPathBaseParam,
  ISuppliersDto
>("stores.suppliers");
const getApis = createGetApi<
  IApiResponse<ISuppliersResponse>,
  IPathByIdParam,
  object
>("stores.suppliers");
const patchApis = createPatchApi<
  IApiResponse<ISuppliersResponse>,
  IPathByIdParam,
  ISuppliersDto
>("stores.suppliers");

export const suppliers = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  active,
  deactive,
  stats,
};
